import { TypedElement } from "../../TypedElement";
import { IInlineEntityElement } from "./types";
import { INLINE_ENTITY_ELEMENT } from "./const";

export const InlineEntityElement = {
  ...TypedElement,
  isInlineEntityElement: (o: any): o is IInlineEntityElement =>
    InlineEntityElement.isTypedElement(o) && o.type === INLINE_ENTITY_ELEMENT,
};
